/* ============================================
   Folk Objects - Enquiry Cart Logic
   Handles auth-gated enquiry submission.
   Reuses Shopify cart as an enquiry cart.
   ============================================ */
(function () {
  'use strict';

  var RETURN_URL_KEY = 'folk_return_url';

  function isLoggedIn() {
    try { return !!localStorage.getItem('folk_token'); } catch (e) { return false; }
  }

  function getUser() {
    try { return JSON.parse(localStorage.getItem('folk_user') || 'null'); } catch (e) { return null; }
  }

  function initAuthState() {
    var signedInEls = document.querySelectorAll('[data-folk-cart-auth="signed-in"]');
    var signedOutEls = document.querySelectorAll('[data-folk-cart-auth="signed-out"]');
    var loggedIn = isLoggedIn();

    signedInEls.forEach(function (el) { el.hidden = !loggedIn; });
    signedOutEls.forEach(function (el) { el.hidden = loggedIn; });
  }

  function storeReturnUrl() {
    try { localStorage.setItem(RETURN_URL_KEY, window.location.href); } catch (e) {}
  }

  function bindLoginButtons() {
    var loginBtns = document.querySelectorAll('#folk-cart-login-btn, .folk-cart-login-btn');
    loginBtns.forEach(function (btn) {
      if (btn.dataset.folkBound) return;
      btn.dataset.folkBound = '1';
      btn.addEventListener('click', function () {
        storeReturnUrl();
      });
    });
  }

  function bindEnquiryButtons() {
    var btns = document.querySelectorAll('#folk-submit-enquiry, #folk-submit-enquiry-main');
    btns.forEach(function (btn) {
      if (btn.dataset.folkBound) return;
      btn.dataset.folkBound = '1';
      btn.addEventListener('click', function () {
        submitEnquiry(btn);
      });
    });
  }

  function refreshAll() {
    initAuthState();
    bindLoginButtons();
    bindEnquiryButtons();
  }

  function getCartData() {
    return fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function submitEnquiry(btn) {
    if (btn.disabled) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Submitting...';

    var user = getUser();
    var token = null;
    try { token = localStorage.getItem('folk_token'); } catch (e) {}

    if (!token || !user) {
      btn.disabled = false;
      btn.textContent = originalText;
      storeReturnUrl();
      window.location.href = '/pages/trade-login';
      return;
    }

    getCartData()
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          alert('Your enquiry cart is empty. Please add products first.');
          btn.disabled = false;
          btn.textContent = originalText;
          return;
        }

        var items = cart.items.map(function (item) {
          var props = item.properties || {};
          var payload = {
            productId: item.product_id,
            variantId: item.variant_id,
            title: item.product_title,
            variantTitle: item.variant_title,
            sku: item.sku,
            quantity: item.quantity,
            price: (item.price / 100).toFixed(2),
            image: item.image,
            url: item.url
          };
          if (props['Customise'] === 'Yes') payload.customise = 'Yes';
          if (props['Request Samples'] === 'Yes') payload.requestSamples = 'Yes';
          if (props['_price_on_request'] === 'Yes') payload.priceOnRequest = 'Yes';
          return payload;
        });

        var payload = {
          user: {
            id: user.id,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            phone: user.phone,
            phoneCode: user.phoneCode,
            businessNature: user.businessNature,
            businessType: user.businessType,
            website: user.website,
            instagram: user.instagram,
            gstNumber: user.gstNumber
          },
          items: items,
          totalPrice: (cart.total_price / 100).toFixed(2),
          currency: cart.currency,
          note: cart.note || '',
          submittedAt: new Date().toISOString()
        };

        return fetch(window.FolkAPI.API_BASE + '/enquiry/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.error || 'Submission failed');
            return clearCart().then(function () {
              setTimeout(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                window.open("https://folkobjects.com/pages/thank-you", "_blank");
              }, 0);

              // showSuccess(btn);
              // Delay cart:refresh so the success message stays visible — otherwise the
              // CartDrawer re-renders on cart:refresh and clobbers the injected HTML.
              // setTimeout(function () {
              //   document.dispatchEvent(new CustomEvent('cart:refresh'));
              // }, 5000);
            });
          });
      })
      .catch(function (err) {
        alert(err.message || 'Could not submit enquiry. Please try again.');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function showSuccess(btn) {
    var container = btn.closest('.folk-enquiry-logged-in') || btn.parentElement;
    container.innerHTML =
      '<div class="folk-enquiry-success">' +
      '<h3>We’ve received your enquiry.</h3>' +
      '<p>Our team will connect with you via email or WhatsApp within 48 hours.</p>' +
      '</div>';
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // Watch for cart drawer DOM changes — Shopify re-renders the drawer
  // after add-to-cart, so auth buttons appear dynamically
  var observer = new MutationObserver(function () {
    refreshAll();
  });
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Also listen to cart events as fallback
  document.addEventListener('cart:change', function () {
    setTimeout(refreshAll, 100);
  });
})();
